




























import { Component, Mixins, Prop, Provide, Vue } from 'vue-property-decorator'

import { AuthMixin } from '@/components/authMixin'
import Breadcrumb from '@/components/Breadcrumb.vue'
import Footer from '@/components/Footer.vue'
import LeftMenu from '@/components/LeftMenu.vue'
import TopMenu from '@/components/TopMenu.vue'
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import Loading from '../components/Loading.vue'
import { getConstants, getFilteredMenuData } from '../service/common'
import {
  BUSSINESS,
  BUSSINESS_SUBJECTS,
  // SENSITIVE_WORDS,
  SUBJECTS,
  USER_GROUPS,
  BUSSINESS_SIDES,
  BUSSINNESS_CATEGORY,
  BUSINESS_APPROVE_REASON,
  BUSINESS_WITH_NULL,
  SENSITIVE_PIC_TYPE,
  SENSITIVE_CONTENT_TYPE,
  SENSITIVE_WORD_TYPE,
  BUSINESS_SOURCE_DATA
} from '../service/constant'
import { getUrlParams } from '../utils/urlUtils'
import store from './store'

@Component({
  components: { Footer, TopMenu, Breadcrumb, LeftMenu, Loading }
})
export default class App extends Mixins(AuthMixin) {
  public localeZHCN = zhCN

  private get hasMenus() {
    return getFilteredMenuData(this.$store.state[USER_GROUPS]).length > 0
  }
  private get blank() {
    return location.pathname === '/cguardian/platform/doc-preview'
  }

  public async mounted() {
    this.tryLogin()
    this.registerLoginInfoSync()

    let ticket = getUrlParams().ticket
    if (ticket) return // block所有网络请求
    if (!this.$store.state[USER_GROUPS] || this.$store.state[USER_GROUPS].length == 0) return // 无效账户stop

    getConstants().then((retData) => {
      if (retData.success) {
        // const dict = retData.data.sensitive_type_data
        // const data = Object.keys(dict).map((key) => ({ value: +key, label: dict[key] }))

        const dict2 = retData.data.subject_data
        const subjects = Object.keys(dict2).map((key) => ({ value: +key, label: dict2[key] }))

        const dict3 = retData.data.business_type_data
        let bizs = Object.keys(dict3).map((key) => ({ value: +key, label: dict3[key] }))
        // 如果有广告项 7001 将广告项置顶
        let ad_idx = bizs.findIndex((n) => n.value === 7001)
        let ad: any = bizs[ad_idx]
        let bizs_result: any = []
        if (ad_idx !== -1) {
          bizs.splice(ad_idx, 1)
          bizs_result = [ad, ...bizs]
        } else {
          bizs_result = bizs
        }
        const bizs_pro = [{ value: -1, label: '请选择' }, ...bizs_result]
        const dict4 = retData.data[BUSSINESS_SUBJECTS]
        const biz_obj_dict = {}
        Object.keys(dict4).forEach((key) => {
          let temp = Object.assign({}, ...dict4[key])
          biz_obj_dict[key] = Object.keys(temp).map((sub) => ({ value: +sub, label: temp[sub] }))
        })

        // 业务方id
        const dict5 = retData.data.business_sides
        const business_sides = Object.keys(dict5).map((key) => ({ value: key, label: dict5[key] }))

        // 获取分类
        const business_category_data = retData.data.business_category_data
        // const dict6 = retData.data.business_category_data
        // const business_category_data = {}
        // Object.keys(dict6).forEach((key) => {
        //   let temp = dict6[key]
        //   business_category_data[key] = [
        //     { value: '', label: '不限' },
        //     ...Object.keys(temp).map((sub) => ({ value: sub, label: temp[sub] }))
        //   ]
        // })

        // 获取拒绝原因
        const dict7 = retData.data.business_approve_reason
        const business_approve_reason = {}
        Object.keys(dict7).forEach((key) => {
          let temp = dict7[key]
          business_approve_reason[key] = [
            ...Object.keys(temp).map((sub) => ({ value: sub, label: temp[sub] }))
          ]
        })

        /**
         * SENSITIVE_WORDS 拆分为图片、敏感词和内容三种违规类型类型，分别维护，并移除 sensitive_type_data 字段
         */
        // 获取图片违规类型
        const dict8 = retData.data.sensitive_pic_type_data
        const sensitive_pic_type_data =
          dict8 && Object.keys(dict8).map((key) => ({ value: +key, label: dict8[key] }))
        // 获取敏感词违规类型
        const dict9 = retData.data.sensitive_word_type_data
        const sensitive_word_type_data =
          dict9 && Object.keys(dict9).map((key) => ({ value: +key, label: dict9[key] }))
        // 获取内容违规类型
        const dict10 = retData.data.sensitive_content_type_data
        const sensitive_content_type_data =
          dict10 && Object.keys(dict10).map((key) => ({ value: +key, label: dict10[key] }))

        // 获取自媒体资源来源
        const dict11 = retData.data.business_source_data
        const business_source_data = dict11

        store.commit('setConstants', {
          // [SENSITIVE_WORDS]: data,
          [SUBJECTS]: subjects,
          [BUSSINESS]: bizs_result,
          [BUSSINESS_SUBJECTS]: biz_obj_dict,
          [BUSSINESS_SIDES]: business_sides,
          [BUSSINNESS_CATEGORY]: business_category_data,
          [BUSINESS_APPROVE_REASON]: business_approve_reason,
          [BUSINESS_WITH_NULL]: bizs_pro,
          [SENSITIVE_WORD_TYPE]: sensitive_word_type_data,
          [SENSITIVE_PIC_TYPE]: sensitive_pic_type_data,
          [SENSITIVE_CONTENT_TYPE]: sensitive_content_type_data,
          [BUSINESS_SOURCE_DATA]: business_source_data
        })
      }
    })
  }
}
